module.exports = __webpack_public_path__ + "static/media/add-user.de30d012.png";